<div class="entry-skeleton-container">
  <img
    ngSrc="assets/images/backgrounds/login-background.png"
    alt="Background image"
    placeholder="assets/images/backgrounds/login-background-placeholder.jpg"
    priority
    fill
  />

  <dbx-language-switcher [language]="$language()" (languageChange)="setLanguage($event)"></dbx-language-switcher>
  <div class="entry-skeleton">
    <div class="skeleton-card">
      <div class="logo"></div>
      <div class="title">{{ 'login.welcomeBack' | translate }}</div>
      <div class="subtitle">{{ 'login.subtitle1' | translate }}</div>
      <div class="subtitle">{{ 'login.subtitle2' | translate }}</div>
    </div>

    <ng-content />
  </div>
</div>
